import React, { useState } from "react";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";

import "./style.scss";
import { deleteOffer, acceptOffer } from "../../services";
import { showSuccessMessage } from "../../redux/action";
import { useDispatch } from "react-redux";

const Offer = (props) => {
  const [showDetails, setShowDetails] = useState(false);
  const { offer, isPending, disabled } = props;
  const disptach = useDispatch();

  const getUserName = () => {
    if (offer?.user?.name) {
      return offer.user.name
        .match(/(^\S\S?|\b\S)?/g)
        .join("")
        .match(/(^\S|\S$)?/g)
        .join("")
        .toUpperCase();
    }
    return "";
  };

  const deleteMyOffer = () => {
    deleteOffer(offer.id).then((response) => {
      disptach(showSuccessMessage("offer deleted successfully"));
      setTimeout(() => {
        disptach(showSuccessMessage(""));
      }, 500);
      props.reload();
    });
  };

  const acceptRequestOffer = () => {
    acceptOffer(offer.id).then((response) => {
      disptach(showSuccessMessage("offer accepted successfully"));
      setTimeout(() => {
        disptach(showSuccessMessage(""));
      }, 500);
      props.reload();
    });
  };
  return (
    <div className={"row offer-collapsed " + (disabled ? " disabled" : "")}>
      <div className="item-info col-1 align-items-center d-flex">
        <Avatar
          label={getUserName()}
          className="mr-2"
          //   size="l"
          style={{
            backgroundColor: "#2196F3",
            color: "#ffffff",
            padding: "20px",
          }}
        />
      </div>
      <div className="item-info col-2">
        <p className="m-0 font-bold text-sm">Energy (kWh)</p>
        <p className="m-0">{offer.energy}</p>
      </div>
      <div className="item-info col-2">
        <p className="m-0 font-bold">price ($ / kWh)</p>
        <p className="m-0">{offer.price}</p>
      </div>
      {disabled && <div className="item-info col-3">
        <p className="m-0 font-bold">status</p>
        <p className="m-0">disabled because of power losses</p>
      </div>}

      {isPending && !disabled && (
        <div className="actions col-2 justify-content-start align-items-center d-flex offset-md-2">
          {!offer.isMyOffer && props.isMyRequest && (
            // <Button
            //  onClick={acceptRequestOffer}
            //   className="text-white edit"
            //   label="Accept Offer"
            // />
            <Button
              onClick={acceptRequestOffer}
              label="Accept Offer"
              className="p-button-sm edit"
            />
          )}
          {offer.isMyOffer && (
            // <Button
            //  onClick={deleteMyOffer}
            //   className="p-button-outlined p-button-rounded delete"
            //   icon="pi pi-trash"
            // />
            <Button
              onClick={deleteMyOffer}
              label="Delete Offer"
              className="p-button-sm delete"
            />
          )}
        </div>
      )}

      <div className="item-info col justify-content-end align-items-center d-flex">
        <p
          onClick={() => setShowDetails(!showDetails)}
          className="m-0 cursor-pointer"
        >
          <i className={showDetails ? "pi pi-angle-up" : "pi pi-angle-down"} />
        </p>
      </div>

      {showDetails && !!offer.comment && !!offer.comment.trim() && (
        <div className="row px-4 my-3">{offer.comment}</div>
      )}
    </div>
  );
};

export default Offer;
